/* WJW collection best sellers. Ranking: Boost legacy API. Display: native lightweight cards.
   No quick add, no DPO mutation, no changes to Boost's existing desktop widget. */
(function () {
  'use strict';
  var API = 'https://services.mybcapps.com/discovery/recommend';

  function safeImage(url) {
    if (typeof url !== 'string' || !url) return '';
    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.protocol !== 'https:' && !(parsed.protocol === 'http:' && parsed.host === window.location.host)) return '';
      // Shopify CDN supports width transforms; request a card-sized image rather than the master.
      if (parsed.hostname === 'cdn.shopify.com') parsed.searchParams.set('width', '360');
      return parsed.href;
    } catch (_) { return ''; }
  }

  function imageFor(product) {
    var img = Array.isArray(product.images_info) && product.images_info[0];
    if (!img && Array.isArray(product.images)) img = product.images[0];
    if (!img) img = product.image;
    return safeImage(typeof img === 'string' ? img : (img && (img.src || img.url)));
  }

  // Match the storefront's "As low as" illustration, not an actual checkout discount.
  function priceFor(product, root) {
    if (!Array.isArray(product.tags) || root.dataset.currency !== root.dataset.shopCurrency) return '';
    if (product.price_min === null || product.price_min === undefined || product.price_min === '') return '';
    var base = Number(product.price_min);
    if (!Number.isFinite(base) || base < 0) return '';
    var tags = product.tags;
    var factor = window.WJWDiscountPricing ? window.WJWDiscountPricing.factor(tags) : null;
    if (factor === null) return '';
    var has = function (tag) { return tags.indexOf(tag) !== -1; };
    var amount = Math.round((base * factor + Number.EPSILON) * 100) / 100;
    try {
      var money = new Intl.NumberFormat(root.dataset.locale || 'en-US', {
        style: 'currency', currency: root.dataset.currency || 'USD'
      }).format(amount);
      return (has('gift-card') || has('Membership') ? '' : 'As low as ') + money;
    } catch (_) { return ''; }
  }

  function makeCard(product, root) {
    var handle = String(product && product.handle || '');
    if (!/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return null;
    var a = document.createElement('a');
    var shopRoot = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    a.href = shopRoot.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
    a.className = 'wjw-collection-bestsellers__card';
    a.dataset.wjwAvailable = (product.available === false || product.available_for_sale === false) ? 'false' : 'true';
    if (product.id) a.dataset.productId = String(product.id).replace(/\D/g, '');
    var title = String(product.title || 'View product');
    a.setAttribute('aria-label', title);
    var url = imageFor(product);
    var media = document.createElement(url ? 'img' : 'span');
    media.className = 'wjw-collection-bestsellers__media';
    if (url) {
      media.src = url;
      media.alt = title;
      media.width = 180;
      media.height = 180;
      media.loading = 'lazy';
      media.decoding = 'async';
    }
    var mediaWrap = document.createElement('span');
    mediaWrap.className = 'wjw-collection-bestsellers__media-wrap';
    if (product.id) mediaWrap.dataset.productId = String(product.id).replace(/\D/g, '');
    mediaWrap.dataset.productHandle = handle;
    mediaWrap.appendChild(media);
    a.appendChild(mediaWrap);
    var info = document.createElement('span');
    info.className = 'wjw-collection-bestsellers__info';
    var name = document.createElement('span');
    name.className = 'wjw-collection-bestsellers__product-title';
    name.textContent = title;
    info.appendChild(name);
    var price = priceFor(product, root);
    if (price) {
      var priceSpan = document.createElement('span');
      priceSpan.className = 'wjw-collection-bestsellers__price';
      priceSpan.textContent = price;
      info.appendChild(priceSpan);
    }
    a.appendChild(info);
    return a;
  }

  async function load(root) {
    if (root.dataset.loaded === '1') return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (!/^collectionpage-[0-9]+$/.test(root.dataset.widgetId || '')) return;
    if (!/^\d+$/.test(root.dataset.collectionId || '')) return;
    if (!root.dataset.shop) return;
    root.dataset.loaded = '1';
    var collectionId = root.dataset.collectionId;
    var tags = ['filter-collect:' + collectionId];
    if (collectionId === '278074753180') tags.push('Coming Soon');
    var limit = Math.min(12, Math.max(4, Number(root.dataset.limit) || 8));
    var body = {
      shop: root.dataset.shop,
      recommendationType: 'bestsellers',
      limit: limit,
      wid: root.dataset.widgetId,
      productIds: [],
      locale: root.dataset.locale || 'en',
      pg: 'product-page', // follows the proven existing WJW collection widget request
      tags: tags
    };
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 8000);
    try {
      var response = await fetch(API, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Boost HTTP ' + response.status);
      var data = await response.json();
      if (!data || !Array.isArray(data.products)) return;
      var rail = root.querySelector('[data-wjw-bestsellers-rail]');
      if (!rail) return;
      var used = new Set();
      var frag = document.createDocumentFragment();
      data.products.forEach(function (product) {
        if (!product || used.has(product.handle)) return;
        var card = makeCard(product, root);
        if (card && used.size < limit) { used.add(product.handle); frag.appendChild(card); }
      });
      if (!used.size) return;
      rail.replaceChildren(frag);
      document.dispatchEvent(new CustomEvent('wjw:cards-inserted', {detail:{root:rail}}));
      root.hidden = false;
      root.classList.add('is-ready');
    } catch (error) {
      // Missing/unavailable widgets should not leave an empty section on the page.
      console.warn('WJW collection Best Sellers:', error.message || error);
    } finally { window.clearTimeout(timeout); }
  }

  function initialize() {
    var matches = Array.prototype.slice.call(document.querySelectorAll('[data-wjw-collection-bestsellers]'));
    if (!matches.length) return;
    var run = function (root) { load(root); };
    if (!('IntersectionObserver' in window)) { matches.forEach(run); return; }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          var section = entry.target.querySelector('[data-wjw-collection-bestsellers]');
          if (section) run(section);
        }
      });
    }, { rootMargin: '240px' });
    matches.forEach(function (root) {
      // The results section itself starts hidden; observe its always-visible parent.
      var host = root.closest('.mobile-collection-page-section') || root;
      // Avoid observing same host twice: a standard collection should only mount one section.
      if (!host.__wjwBestsellersObserved) { host.__wjwBestsellersObserved = true; observer.observe(host); }
    });
    var mql = window.matchMedia('(max-width: 749px)');
    var onChange = function () { if (mql.matches) matches.forEach(run); };
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else if (mql.addListener) mql.addListener(onChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
